
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td width="30%">
                <fieldmagic-text
                  content="Variant"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td width="40%">
                <fieldmagic-text
                  content="Description"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td width="30%">
                <fieldmagic-text
                  content="Linked Product"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngIf="fetching$ | async">
              <tr class="text-center">
                <td colspan="3">
                  <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="! (fetching$ | async)">
              <ng-container *ngIf="variants$ | async as variants">
                <tr
                  *ngIf="variants | blank"
                  class="text-center"
                >
                  <td colspan="3">No variants available.</td>
                </tr>

                <ng-container *ngFor="let variant of variants; let index = index">
                  <tr>
                    <td>{{ variant.name }}</td>
                    <td>{{ variant.description | placeholdWithString }}</td>
                    <td>
                      <ng-container
                        [ngTemplateOutlet]="itemDisplayTmp"
                        [ngTemplateOutletContext]="{
                          variant: variant
                        }"
                      >
                      </ng-container>
                    </td>
                  </tr>

                  <ng-container *ngIf="variant.sub_variants | filled">
                    <tr *ngFor="let sub_variant of variant.sub_variants;">
                      <td>
                        <fieldmagic-indent>
                          <span>{{ sub_variant.name }}</span>
                        </fieldmagic-indent>
                      </td>
                      <td>{{ sub_variant.description | placeholdWithString }}</td>
                      <td>
                        <ng-container
                          [ngTemplateOutlet]="itemDisplayTmp"
                          [ngTemplateOutletContext]="{
                            variant: sub_variant
                          }"
                        >
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <ng-template
      #itemDisplayTmp
      let-variant="variant"
    >
      <fieldmagic-text-link
        [segments]="(variant.item_text | filled) ? ['/items', variant.item_id] : []"
        [label]="variant.item_text"
        [openNewTab]="true"
      >
      </fieldmagic-text-link>
    </ng-template>
  